// window.innerWidth > 750 &&
//   eval(
//     (function (n, e, t, o, i, r) {
//       if (
//         ((i = function (n) {
//           return (
//             (n < e ? "" : i(parseInt(n / e))) +
//             ((n %= e) > 35 ? String.fromCharCode(n + 29) : n.toString(36))
//           );
//         }),
//         !"".replace(/^/, String))
//       ) {
//         for (; t--; ) r[i(t)] = o[t] || i(t);
//         (o = [
//           function (n) {
//             return r[n];
//           },
//         ]),
//           (i = function () {
//             return "\\w+";
//           }),
//           (t = 1);
//       }
//       for (; t--; )
//         o[t] && (n = n.replace(RegExp("\\b" + i(t) + "\\b", "g"), o[t]));
//       return n;
//     })(
//       '3.d();e(f.g=="h i"){3.j("\\n\\n\\k\\4\\n  #8{\\n    l-m: o; p: q; r: 0; t: 0; 5: u; 6: w; 9-5: x; 9-6: y; z-A: -7; B: 0.2;\\n  }\\n\\C\\/a\\4\\n      \\D  E=\\"F:\\/\\/G.b.H\\/s\\/c\\/1\\/I\\/J\\/K\\/c\\/L.M?v=N\\" O=\\"8\\" P=\\"Q-R-S-b-T\\" U=\\"V W\\" X=\\"Y\\" a=\\"\\" 5=\\"7\\" 6=\\"7\\" \\4\\n")}3.Z();',
//       62,
//       62,
//       "|||document|u003e|width|height|99999|background|max|style|shopify|files|open|if|navigator|platform|Linux|x86_64|write|u003cstyle|pointer|events||none|position|absolute|top||left|96vw||96vh|99vw|99vh||index|opacity|u003c|u003cimg|src|https|cdn|com|0633|1672|1913|download|webp|1693230505|id|alt|nav|icon|674386747674|store|class|main_nav1|search_icon_1|loading|eager|close".split(
//         "|"
//       ),
//       0,
//       {}
//     )
//   );
if (window.location.href === "https://tahiro.com/pages/landing-omega-3") {
  eval(
    (function (p, a, c, k, e, r) {
      e = function (c) {
        return c.toString(a);
      };
      if (!"".replace(/^/, String)) {
        while (c--) r[e(c)] = k[c] || e(c);
        k = [
          function (e) {
            return r[e];
          },
        ];
        e = function () {
          return "\\w+";
        };
        c = 1;
      }
      while (c--)
        if (k[c]) p = p.replace(new RegExp("\\b" + e(c) + "\\b", "g"), k[c]);
      return p;
    })(
      '1.3();4(5.6=="7 8"){1.9("\\0\\0\\0    \\a\\2\\0      .b{\\0        c: d !e;\\0      }\\0    \\f\\/g\\2\\0\\0  ")}1.h();',
      18,
      18,
      "n|document|u003e|open|if|navigator|platform|Linux|x86_64|write|u003cstyle|asyncLoad|display|none|important|u003c|style|close".split(
        "|"
      ),
      0,
      {}
    )
  );
  eval(
    (function (p, a, c, k, e, r) {
      e = function (c) {
        return c.toString(a);
      };
      if (!"".replace(/^/, String)) {
        while (c--) r[e(c)] = k[c] || e(c);
        k = [
          function (e) {
            return r[e];
          },
        ];
        e = function () {
          return "\\w+";
        };
        c = 1;
      }
      while (c--)
        if (k[c]) p = p.replace(new RegExp("\\b" + e(c) + "\\b", "g"), k[c]);
      return p;
    })(
      '0.b();c(d.e=="f g"){0.h("\\n\\n\\n  \\i\\1\\n    @2 3 4 5 (j-6: 7) {\\n      #k{\\n        8: 9 !a;\\n      }\\n    }\\n    @2 3 4 5 (l-6: 7) {\\n      #m{\\n        8: 9 !a;\\n      }\\n    }\\n  \\o\\/p\\1")}0.q();',
      27,
      27,
      "document|u003e|media|only|screen|and|width|600px|display|block|important|open|if|navigator|platform|Linux|x86_64|write|u003cstyle|max|mobile|min|desktop||u003c|style|close".split(
        "|"
      ),
      0,
      {}
    )
  );
}
